<ul class="timeline timeline--sm-bullet pl-1 pt-4">
  <li class="timeline__item" *ngFor="let item of history; let i = index; last as isLast">
    <div class="timeline__bullet timeline--sm-bullet">
      <span class="timeline__bullet-shape"></span>
    </div>
    <app-row *ngIf="item?.avlDistance &&
          item.action == ShipmentAction.ArrivePickupLocation ||
          item.action == ShipmentAction.GoodsDelivered" gutter="x-sm">
      <app-col cols="4" class="no-gutters">
        <div class="timeline__item-title ml-4">
          <p class="small">
            {{ "Enum.ShipmentStatus." + item.action | translate}} {{item.createdBy?.userType === UserType.DRIVER &&
            (item.createdBy?.firstName &&
            item.createdBy?.lastName) ? "(" + ("Shipments.DriverAccepted" | translate) + ")" : "(" +
            item.createdBy?.firstName + " " +
            item.createdBy?.lastName + ")"}}
          </p>
        </div>
        <div class="timeline__item-separator" *ngIf="!isLast"></div>
      </app-col>

      <app-col sm="3" class="no-gutters">
        <p class="small" *ngIf="item?.avlDistance &&
          item.action == ShipmentAction.ArrivePickupLocation ||
          item.action == ShipmentAction.GoodsDelivered">
          <span class="timeline__item-content">{{(+item?.avlDistance)?.toFixed(2)}} {{"Shipments.km" | translate}}</span>
        </p>
      </app-col>

      <app-col sm="auto" class="no-gutters">
        <span
          class="timeline__item__content small weight-normal text-500  ml-1">{{item?.createdAt | date : 'dd-MM-yyyy hh:mm aa'}}</span>
      </app-col>
    </app-row>
  </li>
</ul>
